import { saveCookie } from 'core/utils';

class GoogleUtil {
	static login = () => {
		GoogleUtil.authorize();
	}

	static postConnectionLogin = googleUser => {
		const token = googleUser.getAuthResponse().id_token;
		const nextLoc = window.cj.back_url
			? window.cj.back_url
			: window.location.pathname;
		let queryString = window.location.search ? window.location.search : '';

		saveCookie();

		window.location = `/sso/google?token=${token}&next=${nextLoc}${encodeURIComponent(queryString)}`;
	}

	static authorize = () => {
		const authFn = () => {
			window.GoogleAuth.signIn({})
				.then(function(googleUser) {
					GoogleUtil.postConnectionLogin(googleUser);
				})
				.catch(function(error) {
					console.error(JSON.stringify(error, undefined, 2));
				});
		};

		if (window.GoogleAuth) {
			authFn();
		} else {
			var intervalId = setInterval(function() {
				if (window.GoogleAuth) {
					clearInterval(intervalId);
					authFn();
				}
			}, 300);
		}
	}
}

export default GoogleUtil;
